import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtMoney(amount, currency = "USD") {
  if (amount == null) return "—";
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency, currencyDisplay: "narrowSymbol" }).format(Number(amount));
  } catch {
    return `${currency} ${Number(amount).toFixed(2)}`;
  }
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return String(d);
  }
}

// Format a stored calendar date (ISO string or YYYY-MM-DD) in UTC so the
// displayed day never shifts due to the viewer's timezone. Use this for
// values that represent a calendar date (loan start_date, repayment due_date,
// birthdays, etc.) rather than a precise moment in time.
export function fmtCalendarDate(d) {
  if (!d) return "—";
  try {
    const s = String(d);
    // Extract the YYYY-MM-DD part first so we ignore any embedded timezone,
    // then reconstruct as a UTC date. This makes 2026-09-01T12:00:00Z,
    // 2026-09-01T00:00:00Z, and "2026-09-01" all render identically.
    const iso = s.slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
      const [y, m, day] = iso.split("-").map(Number);
      return new Date(Date.UTC(y, m - 1, day)).toLocaleDateString(undefined, {
        year: "numeric", month: "short", day: "numeric", timeZone: "UTC",
      });
    }
    return new Date(d).toLocaleDateString(undefined, {
      year: "numeric", month: "short", day: "numeric", timeZone: "UTC",
    });
  } catch {
    return String(d);
  }
}
